import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
var propTypes = {
  active: PropTypes.bool,
  //是否active
  value: PropTypes.string //唯一标示

};
var defaultProps = {
  active: false
};

var Tab = /*#__PURE__*/function (_React$Component) {
  _inherits(Tab, _React$Component);

  var _super = _createSuper(Tab);

  function Tab() {
    var _this;

    _classCallCheck(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "click", function () {
      _this.props.tabClick(_this.props.value);

      _this.props.onClick && _this.props.onClick(_this.props.value);
    });

    return _this;
  }

  _createClass(Tab, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          clsfix = _this$props.clsfix,
          children = _this$props.children,
          active = _this$props.active,
          value = _this$props.value;
      var classes = "".concat(clsfix, "-item");
      if (active) classes += ' active';
      return /*#__PURE__*/React.createElement("span", {
        className: classes,
        onClick: this.click,
        value: value
      }, children);
    }
  }]);

  return Tab;
}(React.Component);

Tab.propTypes = propTypes;
Tab.defaultProps = defaultProps;
export default Tab;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tabs/src/Tab.js